import type { FaireProductEntity } from "../../entity_types/product";

export const p_bwvg3e5445: FaireProductEntity = {
  token: "p_bwvg3e5445",
  type: "product",
  name: "Boho Bandana Charm Statement Necklace ND-10423",
  brandToken: "b_yfggtce42d",
  brandName: "Oblige by G",
  imageUrl:
    "https://cdn.faire.com/fastly/c0f1d4986cf23bee06e2d1a6d937154e6bc8733782225af33e58eb282c38447b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce2578a67ddb89c9390bf4944cbf7b97859c6dc412102a9aee0f1352b56ea6fe.jpeg",
    "https://cdn.faire.com/fastly/33199f75ec0bc4af7360f80085519cc927cdf83b6a83e61853b77c338d65e6af.jpeg",
    "https://cdn.faire.com/fastly/502f7257207e92716a15b6080167a1354ed29e5ac14933290b4314d4ebb41a65.jpeg",
    "https://cdn.faire.com/fastly/edc8f2a48b3b395253ad5f6635cf22eb3b0a9c99f2ca731f24b6106add898fa5.jpeg",
    "https://cdn.faire.com/fastly/829fbc0990334655832329779576033a68c5e22fb00e8fe8ea1d52dcd152ff47.jpeg",
    "https://cdn.faire.com/fastly/4b07aeba852d6e6a06a41098c0ee3630a949bb253e9557271860ff12bf7849aa.jpeg",
    "https://cdn.faire.com/fastly/6ca9e876d82549770c57cfbe99aaea12067d18ee4ed80a8d22b1314de61f1bd4.jpeg",
    "https://cdn.faire.com/fastly/572a13de805cb335a1fe3dd7954819be59f48ccb318e45be49fced6f3dffea4b.jpeg",
  ],
  priceDollars: 14.55,
  description:
    "Boho Bandana Charm Statement Necklace\nElevate your look with this bold, eclectic charm necklace featuring a chunky gold-tone chain interwoven with colorful bandana-style fabric. Each necklace is adorned with playful charms—stars, crosses, hearts, horseshoes, medallions, and coins—symbolizing luck, love, and protection.\n\nDesign: Gold-tone chain with bandana scarf weave\n\nCharms: Mix of stars, crosses, hearts, horseshoes, medallions & coins\n\nClosure: Adjustable lobster clasp with extender\n\nAvailable Colors: Red, blue, black, beige, white, and multicolor scarf variations\n\nStyle: Bohemian, Western, festival-ready\n\nPerfect for layering with other chains or wearing as a standout statement piece. A must-have for festival season, summer looks, or adding a boho-luxe vibe to any outfit.\n\nND-10429\nTextured Metal Cross Coin Evil Eye Oval Pendant Multi Charm Scarf Necklace\n",
  tags: [],
  msrpDollars: 29.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:25.973Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
